export const utilizationmessages = {
  cardText: {
    members: 'Members',
    totalCost: 'Total Cost',
    medical: 'Medical',
    rx: 'Rx',
    pmpm: 'PMPM',
    pepm: 'PEPM',
  },
  COHORT_DETAILS: {
    TITLE: 'Cohort Details',
    SUBTITLE:
      'Select the properties that you would like to apply to current data',
  },
  costTrenChart: {
    title: 'Procedure Cost Trend',
    subTitle:
      'This visual shows the cost trend of procedure spend for the selected period',
    plotText: 'Procedure Cost Trend - $dataValue.00',
    yAxisTitle: 'Cost',
    months: 'Months',
  },
  page: {
    title: 'Procedure Utilization',
    subTitle:
      'Metrics on procedure spend and the procedure types with the highest plan impact.',
  },
  mainSortField:'totalCharge',
  mainSortOrder:-1,
  ProcedureAndService: {
    title: 'Procedures and Services',
    subTitle:
      'Aggregate your procedures by type and place',
  }
};
